import { render, staticRenderFns } from "./subsScoreStat.vue?vue&type=template&id=3f2e68cd&"
import script from "./subsScoreStat.vue?vue&type=script&lang=js&"
export * from "./subsScoreStat.vue?vue&type=script&lang=js&"
import style0 from "./subsScoreStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports